import ApiService from "../../../ApiService";

const CommentDetailsService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/commentdetails/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    saveComments: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/commentdetails/savecomments", vo, successCallback, failureCallback);
    },
    loadNext: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/commentdetails/loadNext", vo, successCallback, failureCallback);
    },
};

export default CommentDetailsService;
